import React from 'react';

export const ConfirmDeleteDialogue = props => {
    const { isOpen, text, onCancel, handleData, body } = props, { id } = body;
    const endorsementData = {
        id,
        type: 'DELETE',
        stayOpen: true,
    }
    return (
            isOpen
                ?
                <div className="confirm-delete">
                    <h5 className="h5 confirmation-title">Are you sure?</h5>
                    <p className="p-tag">Deleted endorsement cannot be restored.</p>
                    <ul className="buttons-left">
                        <li>
                            <button className="btn btn-primary--ghost" onClick={ () => handleData( endorsementData ) }>
                                <span className="label">Confirm { text }</span>
                            </button>
                        </li>
                        <li>
                            <button className="btn btn-primary" onClick={ () => onCancel() } >
                                <span className="label">Cancel</span>
                            </button>
                        </li>
                    </ul>
                </div>
                :null
            )
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/ConfirmDeleteDialogue.js